import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(5),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6),
    },
  },

  wrapRoot: {
    position: 'relative',
    minHeight: 292,
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      minHeight: 320,
    },
  },

  chart: {
    position: 'absolute',
    left: 0,
    bottom: 10,

    [theme.breakpoints.down('sm')]: {
      bottom: -16,
    },
  },

  panel: {
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      rowGap: theme.spacing(5),
    },
  },
}));
